var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"difficulty-stars",class:{ compact: _vm.compact },on:{"click":function($event){$event.stopPropagation();}}},[_c('el-rate',{attrs:{"value":_vm.normalized,"max":5,"disabled":_vm.readonly,"colors":['#F7BA2A', '#F7BA2A', '#F7BA2A'],"void-color":"#dcdfe6"},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }